import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <div className='flex relative w-full flex-col lg:flex-row lg:h-screen'>
            <MotionContent imgRef={heroRef} height={"what"} className="" translateRange={["20%", "-10%"]}>
              <ImageMedia
                key={"hero" + thisProject.client}
                src={require('./_cover.jpg')}
                className="relative md:landscape:scale-[120%] full object-cover object-center"
              />
            </MotionContent>
            <MotionContent imgRef={heroRef} height={"what"} className="aspect-square" translateRange={["-40%", "20%"]}>
              <ImageMedia
                key={"hero2" + thisProject.client}
                src={require('./assets/hero.png')}
                className="relative md:landscape:scale-[120%] aspect-3/5 full object-cover object-cente"
              />
            </MotionContent>
          </div>

        </div>
      )}
    </ThisProject>
  )
}

export default Content